(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Agency-Section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 图片切换（支持移动端滑动）
    const sectionEl = document.querySelector('.custom-image-product-card');
    if (sectionEl) {
      const thumbs = sectionEl.querySelectorAll('.thumb');
      const mains = Array.from(sectionEl.querySelectorAll('.main-img'));
      const sliderEl = sectionEl.querySelector('.main-img-slider');
      const dots = sectionEl.querySelectorAll('.main-img-dot');
      const prevBtn = sectionEl.querySelector('.main-img-prev');
      const nextBtn = sectionEl.querySelector('.main-img-next');
      let currentIdx = 0;

      const isMobile = () => window.innerWidth < 1024;

      function setActive(idx) {
        currentIdx = Math.max(0, Math.min(idx, mains.length - 1));
        if (isMobile()) {
          if (sliderEl) {
            sliderEl.scrollTo({ left: sliderEl.offsetWidth * currentIdx, behavior: 'smooth' });
          }
        } else {
          thumbs.forEach((t) => t.classList.remove('active'));
          mains.forEach((m) => m.classList.remove('active'));
          if (thumbs[currentIdx]) thumbs[currentIdx].classList.add('active');
          if (mains[currentIdx]) mains[currentIdx].classList.add('active');
        }
        dots.forEach((d, i) => d.classList.toggle('active', i === currentIdx));
        thumbs.forEach((t, i) => t.classList.toggle('active', i === currentIdx));
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => setActive(parseInt(thumb.dataset.index)));
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => setActive(parseInt(dot.dataset.index)));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setActive(currentIdx - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setActive(currentIdx + 1));

      if (sliderEl) {
        sliderEl.addEventListener(
          'scroll',
          () => {
            const idx = Math.round(sliderEl.scrollLeft / (sliderEl.offsetWidth || 1));
            if (idx !== currentIdx) {
              currentIdx = idx;
              dots.forEach((d, i) => d.classList.toggle('active', i === idx));
              thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
            }
          },
          { passive: true }
        );
      }
    }

    // 弹窗按钮触发
    document.querySelectorAll('.btn-modal-trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const blockId = btn.dataset.blockId;
        document.getElementById('modal-' + blockId).style.display = 'flex';
      });
    });

    // 关闭弹窗
    document.querySelectorAll('.modal-close, .dealer-modal-overlay').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (e.target === el || e.target.classList.contains('modal-close')) {
          el.closest('.dealer-modal-overlay').style.display = 'none';
        }
      });
    });

    // 表单提交
    document.querySelectorAll('[id^="dealer-form-"]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const btn = form.querySelector('button[type="submit"]');
        btn.disabled = true;
        btn.textContent = 'Submitting...';

        const data = {
          first_name: form.first_name.value.trim(),
          last_name: form.last_name.value.trim(),
          land: form.country.value,
          post_code: form.postcode.value.trim(),
          book_time: form.booktime.value.trim(),
          email_address: form.email.value.trim(),
          dealer_email: form.dealer_email.value,
        };

        try {
          const res = await fetch('https://accountapi.em-smart.com/appointment/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
          });

          if (res.ok) {
            alert('Thank you! Your inquiry has been sent successfully.');
            form.closest('.dealer-modal-overlay').style.display = 'none';
            form.reset();
          } else {
            throw new Error('Server error');
          }
        } catch (err) {
          alert('Submission failed, please try again later.');
          console.error(err);
        } finally {
          btn.disabled = false;
          btn.textContent = 'Submit';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Circuit-Current-Background"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCircuitCurrent = (section) => {
      if (!section || section.dataset.circuitCurrentInitialized === 'true') return;
      section.dataset.circuitCurrentInitialized = 'true';

      const canvas = section.querySelector('.circuit-current-canvas');
      const ctx = canvas && canvas.getContext('2d');
      if (!canvas || !ctx) return;

      let width = 0;
      let height = 0;
      let pixelRatio = 1;
      let routes = [];
      let pulses = [];
      let animationFrame = null;
      let lastTime = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const colors = [
        [57, 221, 255],
        [71, 255, 186],
        [112, 151, 255]
      ];

      const random = (min, max) => Math.random() * (max - min) + min;
      const pick = (array) => array[Math.floor(Math.random() * array.length)];

      const routeLength = (points) => {
        let length = 0;
        for (let i = 1; i < points.length; i += 1) {
          length += Math.hypot(
            points[i].x - points[i - 1].x,
            points[i].y - points[i - 1].y
          );
        }
        return length;
      };

      const pointAtDistance = (route, distance) => {
        let travelled = 0;
        for (let i = 1; i < route.points.length; i += 1) {
          const from = route.points[i - 1];
          const to = route.points[i];
          const segmentLength = Math.hypot(to.x - from.x, to.y - from.y);
          if (travelled + segmentLength >= distance) {
            const ratio = (distance - travelled) / segmentLength;
            return {
              x: from.x + (to.x - from.x) * ratio,
              y: from.y + (to.y - from.y) * ratio,
              angle: Math.atan2(to.y - from.y, to.x - from.x)
            };
          }
          travelled += segmentLength;
        }
        const last = route.points[route.points.length - 1];
        const previous = route.points[route.points.length - 2];
        return {
          x: last.x,
          y: last.y,
          angle: Math.atan2(last.y - previous.y, last.x - previous.x)
        };
      };

      const makeOrthogonalRoute = (startX, startY, endX, endY, bendCount) => {
        const points = [{ x: startX, y: startY }];
        let x = startX;
        let y = startY;
        const horizontalFirst = Math.random() > 0.5;

        for (let i = 0; i < bendCount; i += 1) {
          const progress = (i + 1) / (bendCount + 1);
          if ((i % 2 === 0) === horizontalFirst) {
            x = startX + (endX - startX) * progress;
          } else {
            y = startY + (endY - startY) * progress;
          }
          points.push({ x, y });
        }

        points.push({ x: endX, y: endY });
        return points;
      };

      const createRoutes = () => {
        routes = [];
        const routeCount = Math.max(24, Math.min(58, Math.floor((width * height) / 18000)));
        const margin = Math.max(24, Math.min(90, width * 0.06));

        for (let i = 0; i < routeCount; i += 1) {
          const startX = random(-margin, width + margin);
          const startY = random(-margin, height + margin);
          const endX = random(-margin, width + margin);
          const endY = random(-margin, height + margin);
          const points = makeOrthogonalRoute(startX, startY, endX, endY, Math.floor(random(1, 4)));
          routes.push({
            points,
            length: routeLength(points),
            color: pick(colors),
            baseOpacity: random(0.1, 0.28),
            lineWidth: random(0.55, 1.15)
          });
        }
      };

      const createPulse = (route) => ({
        route,
        distance: 0,
        speed: random(110, 240),
        radius: random(1.3, 2.5),
        glow: random(8, 18),
        opacity: random(0.75, 1),
        trailWidth: random(1.1, 2.2),
        pause: random(0, 1.4),
        started: false
      });

      const createPulses = () => {
        const pulseCount = Math.max(5, Math.min(13, Math.floor(width / 125)));
        pulses = Array.from({ length: pulseCount }, () => createPulse(pick(routes)));
      };

      const resizeCanvas = () => {
        width = window.innerWidth;
        height = window.innerHeight;
        pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(width * pixelRatio);
        canvas.height = Math.floor(height * pixelRatio);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        createRoutes();
        createPulses();
      };

      const drawRoute = (route) => {
        const [red, green, blue] = route.color;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(route.points[0].x, route.points[0].y);
        route.points.slice(1).forEach((point) => ctx.lineTo(point.x, point.y));
        ctx.strokeStyle = `rgba(${red}, ${green}, ${blue}, ${route.baseOpacity})`;
        ctx.lineWidth = route.lineWidth;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.stroke();
        ctx.restore();
      };

      const drawLitPrefix = (pulse) => {
        const route = pulse.route;
        const progress = pulse.distance / route.length;
        const completedFade = progress > 0.9 ? 1 - (progress - 0.9) / 0.1 : 1;
        const glowOpacity = pulse.opacity * Math.max(0, completedFade);
        const head = pointAtDistance(route, pulse.distance);

        if (pulse.distance > 0 && glowOpacity > 0) {
          const gradient = ctx.createLinearGradient(
            route.points[0].x,
            route.points[0].y,
            head.x,
            head.y
          );
          const [red, green, blue] = route.color;
          gradient.addColorStop(0, `rgba(${red}, ${green}, ${blue}, ${glowOpacity * 0.1})`);
          gradient.addColorStop(0.72, `rgba(${red}, ${green}, ${blue}, ${glowOpacity * 0.35})`);
          gradient.addColorStop(1, `rgba(${red}, ${green}, ${blue}, ${glowOpacity})`);

          ctx.save();
          ctx.beginPath();
          ctx.moveTo(route.points[0].x, route.points[0].y);
          let remaining = pulse.distance;
          for (let i = 1; i < route.points.length; i += 1) {
            const from = route.points[i - 1];
            const to = route.points[i];
            const length = Math.hypot(to.x - from.x, to.y - from.y);
            if (remaining >= length) {
              ctx.lineTo(to.x, to.y);
              remaining -= length;
            } else {
              const ratio = remaining / length;
              ctx.lineTo(from.x + (to.x - from.x) * ratio, from.y + (to.y - from.y) * ratio);
              break;
            }
          }
          ctx.strokeStyle = gradient;
          ctx.lineWidth = pulse.trailWidth;
          ctx.lineJoin = 'round';
          ctx.lineCap = 'round';
          ctx.shadowColor = `rgba(${red}, ${green}, ${blue}, ${glowOpacity})`;
          ctx.shadowBlur = pulse.glow;
          ctx.stroke();
          ctx.restore();
        }

        // Bright current head; it fades together with the filled route at the end.
        const [red, green, blue] = route.color;
        ctx.save();
        ctx.beginPath();
        ctx.arc(head.x, head.y, pulse.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${red}, ${green}, ${blue}, ${glowOpacity})`;
        ctx.shadowColor = `rgba(${red}, ${green}, ${blue}, ${glowOpacity})`;
        ctx.shadowBlur = pulse.glow * 1.5;
        ctx.fill();
        ctx.restore();
      };

      const draw = (time) => {
        const delta = Math.min((time - lastTime) / 1000 || 0, 0.05);
        lastTime = time;
        ctx.clearRect(0, 0, width, height);
        ctx.globalCompositeOperation = 'screen';
        routes.forEach(drawRoute);

        pulses.forEach((pulse) => {
          if (pulse.pause > 0 && !reducedMotion) {
            pulse.pause -= delta;
          } else if (!reducedMotion) {
            pulse.started = true;
            pulse.distance += pulse.speed * delta;
          }
          drawLitPrefix(pulse);
        });

        pulses = pulses.map((pulse) => {
          if (pulse.distance >= pulse.route.length) return createPulse(pick(routes));
          return pulse;
        });
        ctx.globalCompositeOperation = 'source-over';
      };

      const animate = (time) => {
        draw(time);
        animationFrame = window.requestAnimationFrame(animate);
      };

      resizeCanvas();
      draw(0);
      if (!reducedMotion) animationFrame = window.requestAnimationFrame(animate);
      window.addEventListener('resize', resizeCanvas, { passive: true });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail && event.detail.sectionId === section.dataset.id) {
          if (animationFrame) window.cancelAnimationFrame(animationFrame);
          window.removeEventListener('resize', resizeCanvas);
          section.remove();
        }
      });
    };

    const initAll = () => {
      document.querySelectorAll('.section__circuit-current').forEach(initCircuitCurrent);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target && event.target.matches('.section__circuit-current')
        ? event.target
        : event.target && event.target.querySelector('.section__circuit-current');
      initCircuitCurrent(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["father-day-background"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-id="{{ section.id }}"]');
    if (!section) return;
    const canvas = section.querySelector('.father-day-canvas');
    const ctx = canvas.getContext('2d');

    let stars = [];

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    function initStars() {
      stars = [];
      const count = Math.floor((canvas.width * canvas.height) / 8000);
      for (let i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: Math.random() * 1.5 + 0.3,
          alpha: Math.random() * 0.5 + 0.2,
          speed: Math.random() * 0.004 + 0.002,
          offset: Math.random() * Math.PI * 2,
        });
      }
    }

    function draw(time) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(function (s) {
        const alpha = s.alpha + Math.sin(time * s.speed + s.offset) * 0.15;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 255, 255, ' + alpha + ')';
        ctx.fill();
      });
      requestAnimationFrame(draw);
    }

    resize();
    initStars();
    requestAnimationFrame(draw);
    window.addEventListener('resize', function () {
      resize();
      initStars();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tab-with-slider"] && !Shopify.designMode) return;
  try {
    
  var scrollPosition = 0;
  var HomeTabWithSlider = class extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('.htws-tabs');
      this.swiper = null;
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
    }
    init() {
      this.items.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.setIndex(i);
          this.swiper.slideToLoop(i);
        });
      });
      let id = this.getAttribute('sid');
      let className = '.swiper-' + id;
      this.swiper = new Swiper(className, {
        loop: true,
        navigation: {
          nextEl: '.htws-next',
          prevEl: '.htws-prev',
        },
        on: {
          activeIndexChange: (e) => {
            this.setIndex(e.realIndex);
          },
          slideChangeTransitionEnd: function () {
            setTimeout(() => {
              // 获取当前激活的标签页
              var $tab = $('.htws-tabs[show="1"]');
              if (!$tab.length) return;

              // 获取父容器和第一个子标题元素
              var $parent = $tab.parent();
              var $firstSubtitle = $parent.find('.htws-tab-subtitle').first();

              var isDesktop = $(window).width() > 750;

              // 计算目标位置（标签页位置 - 子标题位置）
              if (isDesktop) {
                var $firstSubtitle = $parent.find('.htws-tab-subtitle').first();
              } else {
                var $firstSubtitle = $parent.find('.htws-tabs').first();
              }
              var tabPosition = $tab.position()[isDesktop ? 'top' : 'left'];
              var subtitlePosition = $firstSubtitle.position()[isDesktop ? 'top' : 'left'];
              var scrollPosition = tabPosition - subtitlePosition;

              // 执行滚动（带防抖和动画停止）
              $parent
                .stop(true)
                .animate(isDesktop ? { scrollTop: scrollPosition - 100 } : { scrollLeft: scrollPosition }, 500);
            }, 50); // 延迟确保DOM更新
          },
        },
      });
    }
    setIndex(i) {
      this.items.forEach((ite) => {
        ite.setAttribute('show', '');
      });

      this.items[i].setAttribute('show', '1');
    }
  };
  if (!window.customElements.get('home-tab-with-slider')) {
    window.customElements.define('home-tab-with-slider', HomeTabWithSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucky-wheel"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('lucky-wheel-section')) return;
  const NS = 'http://www.w3.org/2000/svg';
  const REDIRECT_MS = 3000;
  const dismissedOnPage = new Set();
  let activePopup = null;
  let lockedBody = null;

  function readStore(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; }
  }
  function saveStore(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* Private mode: spin still works. */ }
  }
  function lockScroll() {
    if (lockedBody) return;
    lockedBody = { overflow:document.body.style.overflow, padding:document.body.style.paddingRight };
    const gutter = window.innerWidth - document.documentElement.clientWidth;
    if (gutter > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight || '0') + gutter}px`;
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (!lockedBody) return;
    document.body.style.overflow = lockedBody.overflow;
    document.body.style.paddingRight = lockedBody.padding;
    lockedBody = null;
  }
  function svgNode(tag, attrs, text) {
    const node = document.createElementNS(NS, tag);
    Object.entries(attrs || {}).forEach(([key,value]) => node.setAttribute(key,String(value)));
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function point(angle, radius) {
    const a = (angle - 90) * Math.PI / 180;
    return [220 + radius * Math.cos(a), 220 + radius * Math.sin(a)];
  }
  function sameShopUrl(value) {
    try {
      const url = new URL(value,window.location.origin);
      if (!value || url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (url.username || url.password) return null;
      if (url.pathname.replace(/\/$/,'') === location.pathname.replace(/\/$/,'')) return null;
      return url.href;
    } catch (_) { return null; }
  }

  // Image URLs are display-only. Award selection stays on the existing API.
  function safeImageUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value.trim(), window.location.origin);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (_) { return ''; }
  }
  function configuredStyle(configured, prize) {
    const id = String(prize.id || '');
    const byId = id ? configured.find(item => String(item.id || '').trim() === id) : null;
    if (byId) return byId;
    const name = String(prize.name || '').trim().toLowerCase();
    return configured.find(item => !String(item.id || '').trim() && name && String(item.name || '').trim().toLowerCase() === name) || {};
  }
  function prizeAppearance(config, prize, index) {
    const style = configuredStyle(config.prizes || [], prize);
    const custom = config.sliceColorMode === 'custom';
    return {
      id: prize.id, name: prize.name, subtitle: style.subtitle || '',
      image: safeImageUrl(style.image) || safeImageUrl(prize.image_url) || safeImageUrl(prize.imageUrl),
      imageScale: Math.max(70, Math.min(130, Number(style.imageScale) || 100)),
      color: custom && style.color ? style.color : (index % 2 ? '#c94206' : '#fff0c7'),
      textColor: custom && style.textColor ? style.textColor : (index % 2 ? '#fff7dd' : '#64200b')
    };
  }
  function textUnits(text) {
    return [...text].reduce((total, char) => total + (/[^\x00-\xff]/.test(char) ? 1 : /[MW@]/.test(char) ? .85 : .56), 0);
  }
  function labelLines(text, maxUnits, maximum = 2) {
    const chars = [...String(text).trim()];
    const lines = [];
    while (chars.length && lines.length < maximum) {
      let line = '';
      while (chars.length && (!line || textUnits(line + chars[0]) <= maxUnits)) line += chars.shift();
      if (chars.length && lines.length < maximum - 1) {
        const space = line.lastIndexOf(' ');
        if (space > line.length * .35) {
          chars.unshift(...line.slice(space + 1));
          line = line.slice(0, space);
        }
      }
      lines.push(line.trim());
      while (chars[0] === ' ') chars.shift();
    }
    if (chars.length) {
      let last = lines[lines.length - 1];
      while (last && textUnits(last + '…') > maxUnits) last = last.slice(0, -1);
      lines[lines.length - 1] = last.trim() + '…';
    }
    return lines;
  }

  function safeWinner(value) {
    if (!value || typeof value.id !== 'string' || typeof value.display_name !== 'string' || typeof value.prize_name !== 'string' || !Number.isFinite(Date.parse(value.created_at))) return null;
    return {id:value.id,display_name:value.display_name.slice(0,100),prize_name:value.prize_name.slice(0,100),created_at:value.created_at};
  }
  function winnerTime(value) {
    const seconds = Math.max(0,Math.floor((Date.now() - Date.parse(value)) / 1000));
    if (seconds < 60) return 'Just now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)} hr ago`;
    return new Date(value).toLocaleDateString(undefined,{month:'short',day:'numeric'});
  }

  class WinnerTicker {
    constructor(feed,viewport,track,empty,visible,nextItem) {
      Object.assign(this,{feed,viewport,track,empty,visible,nextItem});
      this.rows = [];
      this.reasons = new Set(['inactive']);
      this.disposed = false;
      this.remaining = Number(feed.owner.config.tickerInterval || 3) * 1000;
      this.dwell = this.remaining;
      this.duration = 550;
      this.listen = [];
      const on = (event,fn) => { viewport.addEventListener(event,fn); this.listen.push(() => viewport.removeEventListener(event,fn)); };
      on('mouseenter',() => this.pause('hover',true));
      on('mouseleave',() => this.pause('hover',false));
      on('focusin',() => this.pause('focus',true));
      on('focusout',e => { if (!viewport.contains(e.relatedTarget)) this.pause('focus',false); });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.reasons.add('reduced-motion');
    }
    async fill() {
      if (this.filling || this.disposed || this.moving || this.rows.length >= this.visible + 1) return;
      this.filling = true;
      try {
        while (this.rows.length < this.visible + 1 && !this.disposed) {
          const row = await this.nextItem();
          if (!row) break;
          this.rows.push(row);
        }
        if (!this.disposed) { this.render(); this.schedule(); }
      } finally { this.filling = false; }
    }
    render() {
      this.track.replaceChildren();
      this.empty.hidden = this.rows.length > 0;
      const seen = new Set();
      this.rows.forEach((winner,index) => {
        const row = document.createElement('div');
        row.className = 'lw-winner-row';
        row.setAttribute('role','listitem');
        if (index >= this.visible) row.setAttribute('aria-hidden','true');
        if (index < this.visible && seen.has(winner.id)) {
          row.textContent = 'More luck on the way…';
          row.style.opacity = '.45';
        } else {
          const main = document.createElement('div');main.className = 'lw-winner-main';
          const name = document.createElement('span');name.className = 'lw-winner-name';name.textContent = winner.display_name;
          const prize = document.createElement('span');prize.className = 'lw-winner-prize';prize.textContent = `Won ${winner.prize_name}`;
          const time = document.createElement('time');time.className = 'lw-winner-time';time.dateTime = winner.created_at;time.textContent = winnerTime(winner.created_at);
          main.append(name,prize);row.append(main,time);
        }
        seen.add(winner.id);this.track.append(row);
      });
      this.track.style.transform = 'translateY(0px)';
    }
    schedule(delay = this.remaining) {
      if (this.disposed || this.reasons.size || this.timer || this.moving || this.rows.length < this.visible + 1) return;
      this.remaining = delay;
      this.deadline = Date.now() + delay;
      this.timer = window.setTimeout(() => { this.timer = null; this.remaining = this.dwell; this.advance(); },delay);
    }
    advance() {
      if (this.disposed || this.reasons.size || this.moving) return;
      this.moving = true;
      this.elapsed = 0;
      this.rowHeight = parseFloat(getComputedStyle(this.viewport).getPropertyValue('--lw-row-height')) || 44;
      if (typeof this.track.animate === 'function') {
        this.animation = this.track.animate([{transform:'translateY(0px)'},{transform:`translateY(-${this.rowHeight}px)`}],{duration:this.duration,easing:'ease-in-out',fill:'forwards'});
        this.animation.onfinish = () => this.finish();
      } else this.resumeFallback();
    }
    resumeFallback() {
      if (this.disposed || this.reasons.size) return;
      this.segmentStart = Date.now();
      const rest = Math.max(0,this.duration - this.elapsed);
      this.track.style.transition = `transform ${rest}ms linear`;
      void this.track.offsetWidth;
      this.track.style.transform = `translateY(-${this.rowHeight}px)`;
      this.moveTimer = window.setTimeout(() => { this.moveTimer = null; this.finish(); },rest);
    }
    finish() {
      if (this.disposed) return;
      if (this.animation) { this.animation.cancel(); this.animation = null; }
      this.track.style.transition = 'none';
      this.rows.shift();this.render();
      this.moving = false;this.remaining = this.dwell;
      this.fill().catch(() => {});
    }
    pause(reason,paused) {
      const wasPaused = this.reasons.size > 0;
      if (paused) this.reasons.add(reason); else this.reasons.delete(reason);
      const isPaused = this.reasons.size > 0;
      if (wasPaused === isPaused) return;
      if (isPaused) {
        if (this.timer) { this.remaining = Math.max(0,this.deadline - Date.now()); window.clearTimeout(this.timer); this.timer = null; }
        if (this.animation) this.animation.pause();
        else if (this.moving) {
          this.elapsed = Math.min(this.duration,this.elapsed + Date.now() - this.segmentStart);
          window.clearTimeout(this.moveTimer);this.moveTimer = null;
          this.track.style.transition = 'none';
          this.track.style.transform = `translateY(-${this.rowHeight * this.elapsed / this.duration}px)`;
        }
      } else if (this.animation) this.animation.play();
      else if (this.moving) this.resumeFallback();
      else this.schedule();
    }
    reset() {
      window.clearTimeout(this.timer);window.clearTimeout(this.moveTimer);this.timer = null;this.moveTimer = null;
      if (this.animation) { this.animation.cancel();this.animation = null; }
      this.moving = false;this.remaining = this.dwell;this.rows = [];
      this.track.style.transition = 'none';this.render();
    }
    dispose() {
      this.disposed = true;
      window.clearTimeout(this.timer);window.clearTimeout(this.moveTimer);
      if (this.animation) this.animation.cancel();
      this.listen.forEach(remove => remove());this.track.replaceChildren();
    }
  }

  class WinnerFeed {
    constructor(owner,panel) {
      this.owner = owner;this.panel = panel;this.disposed = false;this.active = false;
      this.latest = [];this.latestIndex = 0;this.pageRows = [];this.pageIndex = 0;this.cursor = null;
      this.requests = new Set();this.total = 0;
      const node = key => panel.querySelector(`[data-lw-${key}]`);
      this.badge = node('live-badge');this.state = node('feed-state');this.note = node('feed-note');this.totalNode = node('winner-total');
      this.latestEmpty = node('latest-empty');this.allEmpty = node('all-empty');
      this.latestTicker = new WinnerTicker(this,node('ticker-latest'),node('latest-track'),this.latestEmpty,1,async() => {
        if (!this.latest.length) return null;
        const item = this.latest[this.latestIndex % this.latest.length];this.latestIndex++;return item;
      });
      this.allTicker = new WinnerTicker(this,node('ticker-all'),node('all-track'),this.allEmpty,2,() => this.nextHistorical());
      this.visibility = () => this.syncVisibility();document.addEventListener('visibilitychange',this.visibility);
    }
    setActive(value) { this.active = value; this.syncVisibility(); }
    syncVisibility() {
      const enabled = this.active && !document.hidden && !this.disposed;
      this.latestTicker.pause('inactive',!enabled);this.allTicker.pause('inactive',!enabled);
      window.clearTimeout(this.refreshTimer);window.clearTimeout(this.retryTimer);
      if (!enabled) { this.requests.forEach(controller => controller.abort());return; }
      this.refresh();
    }
    setStatus(online,message) {
      this.badge.dataset.state = online ? 'online' : 'offline';
      this.state.textContent = online ? 'Live' : 'Syncing';
      if (this.note) {
        if (message) {
          this.note.hidden = false;
          this.note.textContent = message;
        } else {
          this.note.hidden = true;
          this.note.textContent = '';
        }
      }
    }
    async data(cursor = null) {
      const raw = String(this.owner.config.functionUrl || '').trim();
      let url;try { url = new URL(raw); } catch (_) { throw new Error('Winner feed URL is not configured'); }
      if (url.protocol !== 'https:') throw new Error('Feed requires HTTPS');
      url.searchParams.set('action','winners');url.searchParams.set('site',this.owner.config.site || 'US');
      url.searchParams.set('campaign_id',this.owner.config.campaign || 'lucky-2026');url.searchParams.set('limit','20');
      if (cursor) url.searchParams.set('cursor',cursor);else url.searchParams.delete('cursor');
      const headers = {};const key = String(this.owner.config.publicKey || '').trim();
      if (key) headers.apikey = key;if (key.startsWith('eyJ')) headers.Authorization = `Bearer ${key}`;
      const controller = new AbortController();this.requests.add(controller);
      const timeout = window.setTimeout(() => controller.abort(),20000);
      try {
        const response = await fetch(url.href,{method:'GET',headers,signal:controller.signal,credentials:'omit',cache:'no-store'});
        const body = await response.json();
        if (!response.ok || body.success !== true || !Array.isArray(body.latest) || !Array.isArray(body.winners)) throw new Error(body.message || body.error || body.code || `Winner feed HTTP ${response.status}`);
        return {latest:body.latest.map(safeWinner).filter(Boolean),winners:body.winners.map(safeWinner).filter(Boolean),next_cursor:typeof body.next_cursor === 'string' ? body.next_cursor : null,total:Math.max(0,Number(body.total) || 0)};
      } finally { window.clearTimeout(timeout);this.requests.delete(controller); }
    }
    async refresh() {
      if (this.refreshing || !this.active || document.hidden || this.disposed) return;
      this.refreshing = true;
      try {
        const response = await this.data();
        if (this.disposed || !this.active || document.hidden) return;
        if (this.latest[0]?.id !== response.latest[0]?.id) this.latestIndex = 0;
        this.latest = response.latest;this.total = response.total;
        if (!this.initialized || (!this.pageRows.length && response.winners.length)) {
          this.pageRows = response.winners;this.pageIndex = 0;this.cursor = response.next_cursor;this.initialized = true;
        }
        if (!this.latest.length) this.latestTicker.reset();
        if (!this.total) { this.allTicker.reset();this.pageRows = [];this.pageIndex = 0;this.cursor = null; }
        this.totalNode.textContent = `${this.total} records`;
        this.setStatus(true); // no note about masking / poll interval
        if (!this.latest.length) this.latestEmpty.textContent = 'No winners yet — your luck could be next.';
        if (!this.total) this.allEmpty.textContent = 'No winners yet. Be the first.';
        await Promise.all([this.latestTicker.fill(),this.allTicker.fill()]);
      } catch (_) {
        if (!this.disposed && this.active && !document.hidden) {
          this.setStatus(false,'Winner feed will retry shortly. Drawing still works.');
          if (!this.latest.length) this.latestEmpty.textContent = 'Winner feed unavailable';
          if (!this.pageRows.length) this.allEmpty.textContent = 'Waiting for feed…';
        }
      } finally {
        this.refreshing = false;
        if (!this.disposed && this.active && !document.hidden) this.refreshTimer = window.setTimeout(() => this.refresh(),Number(this.owner.config.feedPollSeconds || 15) * 1000);
      }
    }
    async nextHistorical() {
      if (this.disposed || !this.active || document.hidden) return null;
      if (this.pageIndex < this.pageRows.length) return this.pageRows[this.pageIndex++];
      if (!this.initialized || !this.total) return null;
      try {
        const response = await this.data(this.cursor);
        if (this.disposed || !this.active || document.hidden) return null;
        this.pageRows = response.winners;this.pageIndex = 0;this.cursor = response.next_cursor;
        if (!this.pageRows.length) return null;
        return this.pageRows[this.pageIndex++];
      } catch (_) {
        if (!this.disposed && this.active && !document.hidden) {
          this.setStatus(false,'History will resume shortly.');
          this.retryTimer = window.setTimeout(() => this.allTicker.fill(),5000);
        }
        return null;
      }
    }
    addWinner(value) {
      const winner = safeWinner(value);if (!winner || this.disposed) return;
      if (this.latest.some(row => row.id === winner.id)) return;
      this.latest = [winner,...this.latest].slice(0,20);
      this.latestIndex = 0;
      if (!this.latestTicker.moving && !this.latestTicker.reasons.size) { this.latestTicker.reset();this.latestTicker.fill(); }
      if (this.active) this.refresh();
    }
    dispose() {
      this.disposed = true;this.active = false;
      window.clearTimeout(this.refreshTimer);window.clearTimeout(this.retryTimer);
      this.requests.forEach(controller => controller.abort());this.requests.clear();
      document.removeEventListener('visibilitychange',this.visibility);
      this.latestTicker.dispose();this.allTicker.dispose();
    }
  }

  class LuckyWheel extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.initTimer) return;
      this.initTimer = window.setTimeout(() => {
        this.initTimer = null;
        if (this.isConnected && !this.ready) this.init();
      },0);
    }

    init() {
      const config = this.querySelector('[data-lw-config]');
      if (!config) return;
      try { this.config = JSON.parse(config.dataset.json); } catch (_) { return; }
      this.ready = true;
      this.lifecycle = (this.lifecycle || 0) + 1;
      this.result = null;
      this.listeners = [];
      this.timers = new Set();
      this.rotation = 0;
      this.busy = false;
      this.closed = false;
      this.minimized = false;
      this.minimizing = false;
      this.minimizeToken = 0;
      this.destroyed = false;
      this.editor = Boolean(this.config.designMode || (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)));
      this.storageKey = `lucky-wheel:simple:${this.config.site || 'US'}:${this.config.campaign || 'lucky-2026'}`;
      this.dismissKey = `${this.storageKey}:dismiss`;
      this.dockKey = `${this.storageKey}:dock-minimized`;
      this.lastKey = `${this.storageKey}:last-email`;
      this.recordsKey = `${this.storageKey}:records`;
      this.records = this.loadRecords();
      this.prizes = this.editor ? (this.config.prizes || []).filter(p => p.name || p.id).map((p, index) => prizeAppearance(this.config, {...p, name:p.name || p.id}, index)) : [];
      this.catalogReady = false;
      this.catalogLoading = false;
      this.catalogError = '';
      this.nodes = {};
      ['host','card','form','email','consent','error','spin','spin-label','entry','result','prize','code','code-box','code-label','copy','copy-status','countdown','progress','go','result-note','result-kicker','wheel','lights','confetti','close','skip','live','again','caption','hub','result-image','result-img','dock','dock-open','dock-close','dock-wheel'].forEach(name => {
        this.nodes[name] = this.querySelector(`[data-lw-${name}]`);
      });
      if (!this.nodes.form || !this.nodes.wheel) return;
      if (this.nodes.dock) this.nodes.dock.hidden = true;
      this.originalKicker = this.originalKicker || this.nodes['result-kicker'].textContent;
      this.originalCodeLabel = this.originalCodeLabel || this.nodes['code-label'].textContent;
      this.nodes['result-kicker'].textContent = this.originalKicker;
      this.nodes['code-label'].textContent = this.originalCodeLabel;
      this.nodes.entry.hidden = false;
      this.nodes.result.hidden = true;
      if (this.nodes.go) this.nodes.go.hidden = true;
      this.nodes.error.textContent = '';
      this.nodes['copy-status'].textContent = '';
      this.nodes.countdown.textContent = '';
      this.nodes.wheel.style.transition = 'none';
      this.nodes.wheel.style.transform = 'rotate(0deg)';
      this.idleCaption = this.nodes.caption.textContent;
      this.setBusy(false);
      this.drawWheel();
      this.drawLights();
      const panel = this.querySelector('[data-lw-winners]');
      this.winnersFeed = panel ? new WinnerFeed(this,panel) : null;
      if (this.config.mode !== 'popup' && this.winnersFeed) this.winnersFeed.setActive(true);
      this.listen(this.nodes.form,'submit',e => { e.preventDefault(); this.submit(); });
      this.listen(this.nodes.hub,'click',() => {
        if (this.busy || this.editor) return;
        if (!this.emailState().valid) { this.error('Please enter your email first.');this.nodes.email.focus({preventScroll:true});return; }
        this.submit();
      });
      this.listen(this.nodes.email,'input',() => {
        if (!this.busy) { this.nodes.email.removeAttribute('aria-invalid');this.updateForm(); }
      });
      this.listen(this.nodes.email,'blur',() => { if (!this.busy) this.updateForm(true); });
      this.listen(this.nodes.again,'click',() => this.changeEmail());
      this.listen(window,'storage',e => { if (e.key === this.recordsKey && !this.busy) { this.records = this.loadRecords();this.updateForm(); } });
      this.listen(this.nodes.copy,'click',() => this.copyCode());
      this.listen(this.nodes.go,'click',e => {
        if (this.editor) { e.preventDefault(); this.nodes.countdown.textContent = 'Redirects are disabled in the theme editor. Test in store preview.'; }
        this.stopCountdown();
      });
      this.listen(this.nodes.close,'click',() => this.closePopup());
      this.listen(this.nodes.skip,'click',() => this.closePopup());
      this.listen(this.nodes['dock-open'],'click',() => this.openPopup(false,true));
      this.listen(this.nodes['dock-close'],'click',e => { e.preventDefault();e.stopPropagation();this.dismissDock(); });
      this.listen(window,'pageshow',e => {
        if (e.persisted) {
          this.stopCountdown();
          if (this.dialog && this.dialog.open) { if (this.editor) this.closePopup(true);else this.minimizePopup(true); }
        }
      });

      if (this.config.mode === 'popup') {
        this.makeDialog();
        this.listen(document,'shopify:section:select',e => {
          if (this.editor && e.detail && e.detail.sectionId === this.config.sectionId) this.openPopup(true);
        });
        this.listen(document,'shopify:section:deselect',e => {
          if (this.editor && e.detail && e.detail.sectionId === this.config.sectionId) this.closePopup(true);
        });
        const eligible = !this.config.homepageOnly || this.config.homepage;
        if (!this.editor && readStore(this.dockKey) === true && !this.isDismissed()) {
          this.showDock();
        } else if (this.editor || (this.config.autoOpen && eligible)) {
          this.later(() => this.openPopup(this.editor),this.editor ? 0 : Number(this.config.openDelay || 0) * 1000);
        } else if (!this.config.autoOpen && eligible && !this.isDismissed()) this.showDock();
      } else {
        this.nodes.host.hidden = false;
        const previous = readStore(this.lastKey);
        if (this.config.restoreResult && previous && typeof previous.email === 'string' && this.validRecord(this.records[previous.email])) {
          this.nodes.email.value = previous.email;
          this.updateForm();
        }
      }
      this.loadPrizes();
    }

    listen(target,event,callback) {
      if (!target) return;
      target.addEventListener(event,callback);
      this.listeners.push(() => target.removeEventListener(event,callback));
    }
    later(callback,delay) {
      const timer = window.setTimeout(() => {
        this.timers.delete(timer);
        if (!this.destroyed) callback();
      },delay);
      this.timers.add(timer);
      return timer;
    }
    loadRecords() {
      try {
        const value = JSON.parse(localStorage.getItem(this.recordsKey) || '{}');
        return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
      } catch (_) { return {}; }
    }
    validRecord(value) { return Boolean(value && typeof value.name === 'string' && value.name && typeof value.code === 'string'); }
    remember(email,prize) {
      this.records[email] = {...prize,email};
      try { localStorage.setItem(this.recordsKey,JSON.stringify(this.records)); } catch (_) { /* In-memory still valid. */ }
      saveStore(this.lastKey,{email});
    }
    emailState() {
      const email = this.nodes.email.value.trim().toLowerCase();
      const valid = Boolean(email && email.length <= 254 && /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(email) && this.nodes.email.checkValidity());
      return {email,valid,record:valid && this.validRecord(this.records[email]) ? this.records[email] : null};
    }
    updateForm(forceFormat = false) {
      if (this.busy || this.destroyed) return;
      const state = this.emailState();
      if (this.result && this.result.email !== state.email) {
        this.stopCountdown();this.result = null;this.nodes.entry.hidden = false;this.nodes.result.hidden = true;if (this.nodes.go) this.nodes.go.hidden = true;
        this.nodes['copy-status'].textContent = '';this.nodes.confetti.replaceChildren();
      }
      let message = '';
      if (state.record) {
        this.showResult({...state.record,email:state.email,alreadyDrawn:true},false);
        message = `This email already entered. Last prize: “${state.record.name}” (code ${state.record.code}). Try another email.`;
      } else if (state.email && !state.valid && forceFormat) message = 'Please enter a valid email address.';
      else if (this.catalogError) message = this.catalogError;
      this.nodes.error.textContent = message;
      this.nodes.error.classList.toggle('is-duplicate',Boolean(state.record));
      if (forceFormat && state.email && !state.valid) this.nodes.email.setAttribute('aria-invalid','true');
      else this.nodes.email.removeAttribute('aria-invalid');
      this.nodes.spin.disabled = this.editor || !this.catalogReady || !state.valid || Boolean(state.record);
      if (this.nodes.hub) this.nodes.hub.disabled = this.editor || !this.catalogReady || Boolean(state.record);
      this.nodes['spin-label'].textContent = state.record ? 'Email already used' : this.config.spinLabel || 'Spin the wheel';
      this.scheduleDialogFit();
    }
    changeEmail() {
      if (this.busy) return;
      this.stopCountdown();this.result = null;this.nodes.entry.hidden = false;this.nodes.result.hidden = true;if (this.nodes.go) this.nodes.go.hidden = true;
      this.nodes.email.value = '';this.nodes.email.readOnly = false;this.nodes.email.removeAttribute('aria-invalid');
      this.nodes.error.textContent = '';this.nodes['copy-status'].textContent = '';this.nodes.confetti.replaceChildren();
      if (this.nodes.consent) this.nodes.consent.checked = false;
      this.nodes.countdown.textContent = '';this.nodes['result-note'].textContent = '';
      this.updateForm();this.scheduleDialogFit();this.nodes.email.focus({preventScroll:true});
    }
    apiHeaders(json = false) {
      const headers = json ? {'Content-Type':'application/json'} : {};
      const key = String(this.config.publicKey || '').trim();
      if (key) headers.apikey = key;
      if (key.startsWith('eyJ')) headers.Authorization = `Bearer ${key}`;
      return headers;
    }
    async loadPrizes() {
      if (this.catalogLoading || this.destroyed) return;
      this.catalogLoading = true;
      const lifecycle = this.lifecycle;
      const controller = new AbortController();this.catalogController = controller;
      const timeout = window.setTimeout(() => controller.abort(),20000);
      try {
        const url = new URL(String(this.config.functionUrl || '').trim());
        if (url.protocol !== 'https:') throw new Error('API must use HTTPS.');
        url.searchParams.set('action','prizes');url.searchParams.set('site',this.config.site || 'US');url.searchParams.set('campaign_id',this.config.campaign || 'lucky-2026');
        const response = await fetch(url.href,{method:'GET',headers:this.apiHeaders(),signal:controller.signal,credentials:'omit',cache:'no-store'});
        const body = await response.json().catch(() => ({}));
        if (!response.ok || body.success !== true || !Array.isArray(body.prizes)) throw new Error(body.message || body.error || body.code || `Prizes HTTP ${response.status}`);
        if (this.destroyed || this.lifecycle !== lifecycle) return;
        this.prizes = body.prizes.filter(p => p && typeof p.id === 'string' && typeof p.name === 'string' && p.name.trim()).map((p,index) => prizeAppearance(this.config,p,index));
        this.catalogReady = this.prizes.length > 0;
        this.catalogError = this.catalogReady ? '' : 'No prizes available. Please try again later.';
        this.drawWheel();
        if (this.result) this.showResult(this.result,false);
        this.updateForm();
      } catch (error) {
        if (!this.destroyed && this.lifecycle === lifecycle) {
          this.catalogReady = false;
          this.catalogError = error.name === 'TypeError' || error.name === 'AbortError' ? 'Could not load prizes. Check the API connection.' : `Prize load failed: ${error.message}`;
          this.updateForm();
          this.later(() => this.loadPrizes(),15000);
        }
      } finally {
        window.clearTimeout(timeout);this.catalogLoading = false;
        if (this.catalogController === controller) this.catalogController = null;
      }
    }
    drawWheel() {
      const svg = this.nodes.wheel;
      svg.replaceChildren();
      this.drawDockWheel();
      const prefix = `${this.id.replace(/[^a-zA-Z0-9_-]/g,'-')}-slice`;
      const defs = svgNode('defs');
      const gloss = svgNode('radialGradient',{id:`${prefix}-gloss`,cx:'.38',cy:'.24',r:'.78'});
      gloss.append(svgNode('stop',{offset:'0%','stop-color':'#fff7c3','stop-opacity':'.24'}),svgNode('stop',{offset:'55%','stop-color':'#fff7c3','stop-opacity':'0'}),svgNode('stop',{offset:'100%','stop-color':'#7c1800','stop-opacity':'.23'}));
      defs.append(gloss);svg.append(defs);
      if (!this.prizes.length) {
        svg.append(svgNode('circle',{cx:220,cy:220,r:218,fill:'#ffeac0'}));
        svg.append(svgNode('text',{x:220,y:105,'text-anchor':'middle',fill:'#7a290d','font-size':16},'Loading prizes…'));
        return;
      }
      const measure = document.createElement('canvas').getContext('2d');
      const fontFamily = getComputedStyle(svg).fontFamily;
      const constrainText = (attrs,line,width,weight,size) => {
        if (measure) measure.font = `${weight} ${size}px ${fontFamily}`;
        const actual = measure ? measure.measureText(line).width : textUnits(line) * size * 1.15;
        if (actual > width) { attrs.textLength = width;attrs.lengthAdjust = 'spacingAndGlyphs'; }
      };
      const count = this.prizes.length;
      const step = 360 / count;
      // All coordinates are in the 440 × 440 viewBox. Keep content outside
      // radius 74: this clears the proportionally sized hub, hover and focus ring.
      const contentTop = 34;
      const contentBottom = 144;
      const halfAngle = step * Math.PI / 360;
      const tangent = count <= 2 ? Infinity : Math.tan(halfAngle);
      const bandWidth = (top,bottom) => {
        const radial = Math.max(Math.abs(220 - top),Math.abs(220 - bottom));
        const circleWidth = 2 * Math.sqrt(Math.max(0,212 * 212 - radial * radial));
        const wedgeWidth = count <= 2 ? Infinity : 2 * (220 - bottom) * tangent;
        return Math.max(12,Math.min(180,circleWidth - 12,wedgeWidth - 12));
      };
      this.prizes.forEach((prize,index) => {
        const start = index * step - step / 2, end = start + step;
        const a = point(start,218), b = point(end,218);
        const path = `M220 220 L${a.join(' ')} A218 218 0 ${step > 180 ? 1 : 0} 1 ${b.join(' ')} Z`;
        const shape = attrs => count === 1 ? svgNode('circle',{cx:220,cy:220,r:218,...attrs}) : svgNode('path',{d:path,...attrs});
        svg.append(shape({fill:prize.color,stroke:'#ffebbc88','stroke-width':1.4}));
        const clipId = `${prefix}-${index}`;
        const clip = svgNode('clipPath',{id:clipId});clip.append(shape({}));defs.append(clip);
        const clipped = svgNode('g',{'clip-path':`url(#${clipId})`});
        const group = svgNode('g',{transform:`rotate(${index * step} 220 220)`,fill:prize.textColor,class:'lw-prize-content'});
        const flip = index * step > 90 && index * step < 270;
        let fontSize = count > 8 ? 17 : count > 6 ? 20 : 24;
        const minimumSize = count > 8 ? 10 : 12;
        let lines, titleWidth, lineHeight;
        // Reserve two full lines before wrapping, so a long title cannot
        // silently push into its subtitle or image at narrow slice widths.
        do {
          lineHeight = fontSize * 1.15;
          titleWidth = bandWidth(contentTop,contentTop + lineHeight * 2);
          lines = labelLines(prize.name,titleWidth / fontSize,2);
          if (!lines.some(line => line.endsWith('…')) || fontSize <= minimumSize) break;
          fontSize -= 1;
        } while (fontSize >= minimumSize);
        const titleHeight = lineHeight * lines.length;
        const titleBottom = contentTop + titleHeight;
        titleWidth = bandWidth(contentTop,titleBottom);
        const subtitleSize = count > 8 ? 9 : 10.5;
        const subtitleTop = titleBottom + 4;
        const subtitleBottom = prize.subtitle ? subtitleTop + subtitleSize * 1.2 : titleBottom;
        const imageTop = subtitleBottom + 14;
        const heightLimit = Math.max(0,contentBottom - imageTop);
        // A square's INNER corners must fit the wedge as well as the circle.
        // Merely sizing against the chord at its center causes clipped images.
        const wedgeLimit = count <= 2 ? Infinity : (2 * tangent * (220 - imageTop) - 12) / (1 + 2 * tangent);
        const circleLimit = 2 * Math.sqrt(Math.max(0,208 * 208 - Math.pow(220 - imageTop,2)));
        const baseSize = count <= 2 ? 66 : 60;
        const scale = Math.max(70,Math.min(130,Number(prize.imageScale) || 100)) / 100;
        const imageSize = Math.max(0,Math.min(baseSize * scale,heightLimit,wedgeLimit,circleLimit));
        const imageCenter = imageTop + imageSize / 2;
        if (imageSize > 0) {
          // The image has its own bounded slot; the full product is contained,
          // not cropped. Errors use exactly the same safe slot for the gift icon.
          const media = svgNode('g',{class:'lw-prize-media'});
          media.append(svgNode('rect',{x:220-imageSize/2-2,y:imageTop-2,width:imageSize+4,height:imageSize+4,rx:Math.min(9,imageSize*.15),fill:prize.textColor,'fill-opacity':'.055',stroke:prize.textColor,'stroke-opacity':'.10','stroke-width':'.8',class:'lw-prize-image-frame'}));
          if (prize.image) {
            const image = svgNode('image',{href:prize.image,x:220-imageSize/2,y:imageTop,width:imageSize,height:imageSize,preserveAspectRatio:'xMidYMid meet',class:'lw-prize-image',transform:flip ? `rotate(180 220 ${imageCenter})` : ''});
            image.addEventListener('error',() => { image.remove();this.drawPrizeSymbol(media,prize,imageSize,imageCenter,flip); },{once:true});
            media.append(image);
          } else this.drawPrizeSymbol(media,prize,imageSize,imageCenter,flip);
          group.append(media);
        }
        // Render copy last. Flip the complete title block about ITS center,
        // rather than flipping two-line text about a hard-coded baseline.
        const copy = svgNode('g',{class:'lw-prize-copy'});
        const title = svgNode('g',{class:'lw-prize-title-block',transform:flip ? `rotate(180 220 ${contentTop + titleHeight/2})` : ''});
        title.append(svgNode('title',{},prize.name));
        lines.forEach((line,i) => {
          const attrs = {x:220,y:contentTop + fontSize * .86 + i * lineHeight,'text-anchor':'middle','font-size':fontSize,'font-weight':800,class:'lw-prize-title'};
          constrainText(attrs,line,titleWidth,800,fontSize);
          title.append(svgNode('text',attrs,line));
        });
        copy.append(title);
        if (prize.subtitle) {
          const width = bandWidth(subtitleTop,subtitleBottom);
          const line = labelLines(prize.subtitle,width / subtitleSize,1)[0];
          const attrs = {x:220,y:subtitleTop + subtitleSize * .86,'text-anchor':'middle','font-size':subtitleSize,'font-weight':600,opacity:'.78',class:'lw-prize-subtitle',transform:flip ? `rotate(180 220 ${(subtitleTop + subtitleBottom)/2})` : ''};
          constrainText(attrs,line,width,600,subtitleSize);
          const subtitle = svgNode('text',attrs,line);
          subtitle.append(svgNode('title',{},prize.subtitle));
          copy.append(subtitle);
        }
        group.append(copy);clipped.append(group);svg.append(clipped);
      });
      svg.append(svgNode('circle',{cx:220,cy:220,r:218,fill:`url(#${prefix}-gloss)`,'pointer-events':'none'}));
      svg.append(svgNode('circle',{cx:220,cy:220,r:217,fill:'none',stroke:'#78300b','stroke-width':2.5}));
    }
drawPrizeSymbol(group, prize, size, center = 128, flip = false) {
  const symbol = svgNode('g', {
    transform: `translate(220 ${center}) rotate(${flip ? 180 : 0}) scale(${size / 90})`,
    class: 'lw-prize-symbol'
  });

  // 同时支持 $、€、£
  const amount = String(prize.name).match(/[\$€£]\s?\d+(?:[.,]\d+)?/);

  if (amount) {
    // 漂亮的金额票券（$20 OFF / €20 OFF / £20 OFF 都会走这里）
    symbol.append(svgNode('path', {
      d: 'M-35-25H35V-17Q27-13 35-9V9Q27 13 35 17V25H-35V17Q-27 13-35 9V-9Q-27-13-35-17Z',
      fill: '#ffd475',
      stroke: '#c37d21',
      'stroke-width': 1.5
    }));
    symbol.append(svgNode('rect', {
      x: -29, y: -19, width: 58, height: 38, rx: 2,
      fill: 'none', stroke: '#cc8c31', 'stroke-dasharray': '2 2'
    }));
    symbol.append(svgNode('text', {
      x: 0, y: 0, 'text-anchor': 'middle',
      'font-size': 19, 'font-weight': 900, fill: '#74300f'
    }, amount[0]));  // 直接显示 $20 / €20 / £20
    symbol.append(svgNode('text', {
      x: 0, y: 16, 'text-anchor': 'middle',
      'font-size': 11, 'font-weight': 850, fill: '#74300f'
    }, 'OFF'));
  } else {
    // 没有金额的奖品继续用礼物盒
    symbol.append(svgNode('rect', {
      x: -26, y: -10, width: 52, height: 38, rx: 3,
      fill: '#ffd887', stroke: '#c57b22', 'stroke-width': 1.4
    }));
    symbol.append(svgNode('rect', {
      x: -30, y: -17, width: 60, height: 12, rx: 2,
      fill: '#ffeab7', stroke: '#c57b22', 'stroke-width': 1.4
    }));
    symbol.append(svgNode('path', {
      d: 'M-5-17V28H5V-17M0-17C-31-20-22-43-8-29L0-17C31-20 22-43 8-29Z',
      fill: '#ed9b2c', stroke: '#b75c11', 'stroke-width': 1.8
    }));
  }
  group.append(symbol);
}
    resolvePrizeIndex(prize) {
      let index = this.prizes.findIndex(p => prize.id && String(p.id) === String(prize.id));
      if (index < 0) index = this.prizes.findIndex(p => p.name.trim().toLowerCase() === prize.name.trim().toLowerCase());
      return index;
    }
    drawLights() {
      this.nodes.lights.replaceChildren();
      for (let index = 0; index < 12; index++) {
        const a = index * Math.PI * 2 / 12;
        const dot = document.createElement('i');
        dot.style.left = `${50 + 47 * Math.sin(a)}%`;
        dot.style.top = `${50 - 47 * Math.cos(a)}%`;
        dot.setAttribute('aria-hidden','true');
        this.nodes.lights.append(dot);
      }
    }

    drawDockWheel() {
      const svg = this.nodes['dock-wheel'];
      if (!svg) return;
      svg.replaceChildren();
      // The small wheel is a decorative shortcut, not a second lottery.
      const count = this.prizes.length || 6;
      const step = 360 / count;
      for (let index = 0; index < count; index++) {
        const a = point(index * step - step / 2,218), b = point(index * step + step / 2,218);
        const fill = this.prizes[index]?.color || (index % 2 ? '#c94206' : '#fff0c7');
        svg.append(count === 1 ? svgNode('circle',{cx:220,cy:220,r:218,fill}) : svgNode('path',{d:`M220 220 L${a.join(' ')} A218 218 0 ${step > 180 ? 1 : 0} 1 ${b.join(' ')} Z`,fill,stroke:'#713211','stroke-width':3}));
      }
    }
    makeDialog() {
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'lw-dialog';
      this.dialog.id = `${this.id}-dialog`;
      this.dialog.setAttribute('aria-labelledby',`${this.id}-heading`);
      this.dialog.setAttribute('aria-modal','true');
      this.dialogStage = document.createElement('div');
      this.dialogStage.className = 'lw-dialog-stage';
      this.dialogStage.append(this.nodes.card);
      this.dialog.append(this.dialogStage);
      this.append(this.dialog);
      this.listen(window,'resize',() => this.scheduleDialogFit());
      if (window.visualViewport) {
        this.listen(window.visualViewport,'resize',() => this.scheduleDialogFit());
        this.listen(window.visualViewport,'scroll',() => this.scheduleDialogFit());
      }
      if (typeof ResizeObserver === 'function') {
        this.fitObserver = new ResizeObserver(() => this.scheduleDialogFit());
        this.fitObserver.observe(this.nodes.card);
      }
      this.listen(this.dialog,'cancel',e => { e.preventDefault(); this.closePopup(); });
      this.listen(this.dialog,'click',e => {
        if (!this.config.backdropClose || e.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) this.closePopup();
      });
      this.listen(this.dialog,'keydown',e => {
        if (e.key === 'Escape') { e.preventDefault(); this.closePopup(); }
        if (e.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href],summary,[tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = focusable[0],last = focusable[focusable.length - 1];
        if (!first) { e.preventDefault(); return; }
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    scheduleDialogFit() {
      if (!this.dialog || !this.dialog.open || this.destroyed || this.fitFrame) return;
      this.fitFrame = window.requestAnimationFrame(() => {
        this.fitFrame = null;
        if (this.dialog && this.dialog.open && !this.destroyed) this.fitDialog();
      });
    }
    fitDialog() {
      const viewport = window.visualViewport;
      const viewportWidth = viewport ? viewport.width : window.innerWidth;
      const viewportHeight = viewport ? viewport.height : window.innerHeight;
      const gap = viewportWidth < 750 ? 16 : 32;
      const configuredWidth = parseFloat(getComputedStyle(this).getPropertyValue('--lw-width')) || 1040;
      const width = Math.max(1,Math.min(configuredWidth,viewportWidth - gap));
      const availableHeight = Math.max(1,viewportHeight - gap);
      const card = this.nodes.card;
      this.dialog.style.setProperty('--lw-fit-width',`${width}px`);
      const height = Math.max(card.offsetHeight,card.scrollHeight);
      const scale = Math.min(1,availableHeight / Math.max(1,height));
      this.dialog.style.setProperty('--lw-fit-scale',String(scale));
      this.dialog.style.width = `${width * scale}px`;
      this.dialogStage.style.height = `${Math.ceil(height * scale)}px`;
      this.dialog.style.left = `${(viewport ? viewport.offsetLeft : 0) + viewportWidth / 2}px`;
      this.dialog.style.top = `${(viewport ? viewport.offsetTop : 0) + viewportHeight / 2}px`;
    }
    isDismissed() {
      if (dismissedOnPage.has(this.storageKey) || this.closed) return true;
      if (this.config.dismissPolicy === 'page') return false;
      if (this.config.dismissPolicy === 'day') {
        try {
          const stamp = Number(localStorage.getItem(this.dismissKey));
          return stamp > 0 && Date.now() - stamp < 86400000;
        } catch (_) { return false; }
      }
      return Boolean(readStore(this.dismissKey));
    }
    isSuppressed() {
      return this.isDismissed() || this.minimized || this.minimizing || Boolean(readStore(this.lastKey));
    }
    showDock(focus = false) {
      if (this.config.mode !== 'popup' || !this.nodes.dock || this.destroyed || this.closed) return;
      this.minimized = true;
      this.nodes.dock.hidden = false;
      this.nodes['dock-open'].setAttribute('aria-expanded','false');
      if (focus) this.nodes['dock-open'].focus({preventScroll:true});
    }
    hideDock() {
      if (this.nodes.dock) this.nodes.dock.hidden = true;
    }
    openPopup(force = false,fromDock = false) {
      if (!this.dialog || this.dialog.open || this.destroyed || this.minimizing) return;
      if (!force && (fromDock ? this.isDismissed() : this.isSuppressed())) return;
      if (activePopup && activePopup !== this) {
        if (this.editor && force) activePopup.closePopup(true);
        else return;
      }
      this.closed = false;
      if (fromDock && !this.result && !this.nodes.email.value) {
        const previous = readStore(this.lastKey);
        if (previous && typeof previous.email === 'string' && this.validRecord(this.records[previous.email])) {
          this.nodes.email.value = previous.email;this.updateForm();
        }
      }
      this.previousFocus = document.activeElement;
      if (!this.nodes.dock || !this.nodes.dock.contains(document.activeElement)) this.pageFocus = document.activeElement;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else {
        this.backdrop = document.createElement('div');
        this.backdrop.className = 'lw-fallback-backdrop';
        this.append(this.backdrop);
        this.listen(this.backdrop,'click',() => { if (this.config.backdropClose) this.closePopup(); });
        this.dialog.classList.add('lw-fallback');
        this.dialog.setAttribute('open','');
      }
      this.minimized = false;this.hideDock();
      if (!this.editor) saveStore(this.dockKey,false);
      if (this.nodes['dock-open']) this.nodes['dock-open'].setAttribute('aria-expanded','true');
      activePopup = this;
      lockScroll();this.fitDialog();
      if (this.winnersFeed) this.winnersFeed.setActive(true);
      this.nodes.close.focus({preventScroll:true});
    }
    hideDialog() {
      if (this.winnersFeed) this.winnersFeed.setActive(false);
      if (this.dialog?.open) {
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
      }
      if (this.backdrop) { this.backdrop.remove();this.backdrop = null; }
      if (activePopup === this) { activePopup = null;unlockScroll(); }
    }
    cancelMinimize() {
      this.minimizeToken++;
      window.clearTimeout(this.minimizeTimer);this.minimizeTimer = null;
      if (this.minimizeAnimation) { this.minimizeAnimation.cancel();this.minimizeAnimation = null; }
      this.minimizing = false;
    }
    minimizePopup(immediate = false) {
      if (!this.dialog?.open || this.destroyed || this.minimizing || (!immediate && (this.busy || this.counting))) return;
      this.stopCountdown();
      if (immediate && this.busy) this.cancelActivity();
      this.minimizing = true;this.setCloseDisabled(true);
      if (!this.editor) saveStore(this.dockKey,true);
      const token = ++this.minimizeToken;
      const finish = () => {
        if (token !== this.minimizeToken || this.destroyed) return;
        window.clearTimeout(this.minimizeTimer);this.minimizeTimer = null;
        this.hideDialog();
        if (this.minimizeAnimation) { this.minimizeAnimation.cancel();this.minimizeAnimation = null; }
        this.minimizing = false;this.setCloseDisabled(this.busy || this.counting);
        this.showDock(true);
      };
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (immediate || reduced || typeof this.dialog.animate !== 'function') { finish();return; }
      const rect = this.dialog.getBoundingClientRect();
      const viewport = window.visualViewport;
      const width = viewport?.width || window.innerWidth, height = viewport?.height || window.innerHeight;
      const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
      const targetX = left + (this.config.dockSide === 'left' ? 32 : width - 32);
      const percent = Math.max(10,Math.min(90,Number(this.config.dockVerticalPosition) || 55));
      const targetY = top + height * percent / 100;
      const dx = targetX - rect.left - rect.width / 2, dy = targetY - rect.top - rect.height / 2;
      this.minimizeAnimation = this.dialog.animate([
        {transform:getComputedStyle(this.dialog).transform,opacity:1},
        {transform:`translate(calc(-50% + ${dx}px),calc(-50% + ${dy}px)) scale(.08)`,opacity:0}
      ],{duration:260,easing:'cubic-bezier(.4,0,.7,1)',fill:'forwards'});
      this.minimizeAnimation.onfinish = finish;
      this.minimizeTimer = window.setTimeout(finish,340);
    }
    closePopup(force = false) {
      // All visitor-facing close gestures minimize. Only the dock X dismisses.
      if (!force) { this.minimizePopup();return; }
      this.cancelMinimize();this.stopCountdown();
      if (this.busy) this.cancelActivity();
      this.hideDialog();this.hideDock();this.minimized = false;
      this.setCloseDisabled(false);
      if (this.previousFocus?.isConnected && !this.destroyed && !this.nodes.dock?.contains(this.previousFocus)) this.previousFocus.focus({preventScroll:true});
    }
    dismissDock() {
      if (!this.minimized || this.minimizing || this.busy || this.destroyed) return;
      this.cancelMinimize();this.stopCountdown();this.hideDialog();this.hideDock();
      this.minimized = false;this.closed = true;
      if (this.nodes['dock-open']) this.nodes['dock-open'].setAttribute('aria-expanded','false');
      if (!this.editor) {
        saveStore(this.dockKey,false);
        dismissedOnPage.add(this.storageKey);
        if (this.config.dismissPolicy === 'day') {
          try { localStorage.setItem(this.dismissKey,String(Date.now())); } catch (_) { /* Page-only dismiss fallback. */ }
        } else if (this.config.dismissPolicy !== 'page') saveStore(this.dismissKey,true);
      }
      if (this.pageFocus?.isConnected && !this.nodes.dock?.contains(this.pageFocus)) this.pageFocus.focus({preventScroll:true});
    }

    async submit() {
      if (this.busy || this.destroyed || this.minimizing || this.minimized) return;
      if (this.editor) { this.error('Please enter the draw on the live storefront preview.');return; }
      const state = this.emailState();
      if (state.record) { this.updateForm();return; }
      if (!state.valid) { this.error(state.email ? 'Please enter a valid email address.' : 'Please enter your email.');this.nodes.email.focus();return; }
      if (!this.catalogReady) { this.error(this.catalogError || 'Prizes are still loading. Please try again.');return; }
      if (this.nodes.consent && !this.nodes.consent.checked) { this.error('Please accept the rules and privacy policy.');this.nodes.consent.focus();return; }
      const lifecycle = this.lifecycle;
      const email = state.email;this.nodes.email.value = email;
      this.stopCountdown();this.result = null;this.nodes.result.hidden = true;
      this.nodes.error.textContent = '';this.setBusy(true,'Drawing…');
      try {
        const prize = await this.requestPrize(email);
        if (this.destroyed || this.lifecycle !== lifecycle) return;
        prize.email = email;prize.timestamp = Date.now();this.remember(email,prize);this.result = prize;
        if (prize.alreadyDrawn) { this.setBusy(false);this.updateForm();return; }
        let index = this.resolvePrizeIndex(prize);
        if (index < 0) { await this.loadPrizes();index = this.resolvePrizeIndex(prize); }
        if (this.destroyed || this.lifecycle !== lifecycle) return;
        this.nodes['spin-label'].textContent = 'Drawing…';this.nodes.live.textContent = 'Revealing your prize.';
        if (index >= 0) await this.animateWheel(index);
        if (this.destroyed || this.lifecycle !== lifecycle) return;
        this.setBusy(false);this.showResult(prize,true);
      } catch (error) {
        if (this.destroyed || this.lifecycle !== lifecycle) return;
        this.setBusy(false);this.error(error.message || 'Draw failed. Please try again.');
      }
    }
    setBusy(value,label) {
      this.busy = value;this.nodes.email.readOnly = value;
      this.nodes.card.classList.toggle('is-spinning',value);
      this.nodes.caption.textContent = value ? 'Drawing…' : this.idleCaption || 'Spin for a surprise';
      this.nodes.wheel.setAttribute('aria-label',value ? 'Drawing in progress' : 'Lucky wheel showing available prizes');
      if (this.nodes.consent) this.nodes.consent.disabled = value;
      const state = this.emailState();
      this.nodes.spin.disabled = value || this.editor || !this.catalogReady || !state.valid || Boolean(state.record);
      if (this.nodes.again) this.nodes.again.disabled = value;
      this.nodes['spin-label'].textContent = value ? label || 'Drawing…' : (state.record ? 'Email already used' : this.config.spinLabel || 'Spin the wheel');
      if (this.nodes.hub) {
        this.nodes.hub.disabled = value || this.editor || !this.catalogReady || Boolean(state.record);
        this.nodes.hub.setAttribute('aria-label',value ? 'Drawing in progress' : 'Submit email and spin the prize wheel');
      }
      this.nodes.form.setAttribute('aria-busy',String(value));this.setCloseDisabled(value || this.counting);
      this.scheduleDialogFit();
    }
    setCloseDisabled(value) {
      [this.nodes.close,this.nodes.skip].forEach(node => { if (node) node.disabled = Boolean(value || this.minimizing); });
    }
    error(message) {
      this.nodes.error.textContent = String(message);
      this.nodes.live.textContent = String(message);
    }

    buildPayload(email) {
      const params = new URLSearchParams(window.location.search);
      const payload = {email,site:this.config.site || 'US',campaign_id:this.config.campaign || 'lucky-2026',consent:this.nodes.consent ? this.nodes.consent.checked : true,landing_page:window.location.href,referrer:document.referrer || null};
      payload._receive_email = String(this.config.receiveEmail || '').trim() || null;
      ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid'].forEach(key => { if (params.has(key)) payload[key] = params.get(key); });
      return payload;
    }
    normalizePrize(body) {
      const prize = body && body.prize;
      if (!prize || typeof prize.name !== 'string' || !prize.name.trim()) return null;
      return {id:String(prize.id || prize.prize_id || ''),name:prize.name.trim(),code:prize.code == null ? '' : String(prize.code),alreadyDrawn:false,winner:safeWinner(body.winner),drawn_at:body.drawn_at || null};
    }
    async requestPrize(email) {
      const fn = String(this.config.functionUrl || '').trim();
      if (!fn) throw new Error('Draw API is not configured. Please contact the store.');
      let url;
      try { url = new URL(fn); } catch (_) { throw new Error('Draw API URL is invalid. Please contact the store.'); }
      if (url.protocol !== 'https:') throw new Error('Draw API must use HTTPS.');
      const headers = {'Content-Type':'application/json'};
      const key = String(this.config.publicKey || '').trim();
      if (key) headers.apikey = key;
      if (key.startsWith('eyJ')) headers.Authorization = `Bearer ${key}`;
      const controller = new AbortController();
      this.requestController = controller;
      let timedOut = false;
      const timeout = window.setTimeout(() => { timedOut = true; controller.abort(); },25000);
      try {
        const response = await fetch(url.href,{method:'POST',headers,body:JSON.stringify(this.buildPayload(email)),signal:controller.signal,credentials:'omit'});
        const body = await response.json().catch(() => ({}));
        const prize = this.normalizePrize(body);
        if (response.status === 409 || body.code === 'ALREADY_DRAWN') {
          if (prize) return {...prize,alreadyDrawn:true};
          throw new Error(body.message || 'This email already entered. Contact the store to recover a prize.');
        }
        if (response.ok && body.success === true && prize) return prize;
        if (response.status === 429) throw new Error('Too many requests. Please try again shortly.');
        throw new Error(String(body.message || body.error || body.code || `Draw API HTTP ${response.status}`));
      } catch (err) {
        if (timedOut) throw new Error('Request timed out. The prize may already be claimed. Retry with the same email; do not submit a different email.');
        if (err.name === 'TypeError') throw new Error('Network error. The prize may already be claimed. Retry later with the same email.');
        throw err;
      } finally {
        window.clearTimeout(timeout);
        if (this.requestController === controller) this.requestController = null;
      }
    }

    randomSpinDuration() {
      const clamp = (value,fallback) => {
        const number = Number(value);
        return Math.max(1,Math.min(20,Number.isFinite(number) && number > 0 ? number : fallback));
      };
      const first = clamp(this.config.spinMinSeconds,5), second = clamp(this.config.spinMaxSeconds,8);
      const minimum = Math.round(Math.min(first,second) * 1000);
      const maximum = Math.round(Math.max(first,second) * 1000);
      // Visual timing only: this never selects or changes a prize.
      return minimum + Math.floor(Math.random() * (maximum - minimum + 1));
    }
    animateWheel(index) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration = reduced ? 120 : this.randomSpinDuration();
      const step = 360 / this.prizes.length;
      const desired = (360 - index * step) % 360;
      const current = ((this.rotation % 360) + 360) % 360;
      const turns = reduced ? 0 : Math.max(5,Math.round(duration / 1000 * 1.4));
      const target = this.rotation + 360 * turns + (desired - current + 360) % 360;
      const wheel = this.nodes.wheel;
      return new Promise(resolve => {
        this.spinResolve = resolve;
        let animation = null;
        const finish = () => {
          if (this.spinResolve !== resolve) return;
          window.clearTimeout(this.spinTimer);this.spinTimer = null;
          wheel.style.transition = 'none';wheel.style.transform = `rotate(${target}deg)`;
          this.rotation = target;this.spinResolve = null;
          if (animation) animation.cancel();
          if (this.wheelAnimation === animation) this.wheelAnimation = null;
          resolve();
        };
        if (typeof wheel.animate === 'function' && !reduced) {
          animation = wheel.animate([{transform:`rotate(${this.rotation}deg)`},{transform:`rotate(${target}deg)`}],{duration,easing:'cubic-bezier(.14,.76,.2,1)',fill:'forwards'});
          this.wheelAnimation = animation;animation.onfinish = finish;
        } else {
          wheel.style.transition = `transform ${duration}ms cubic-bezier(.14,.76,.2,1)`;
          void wheel.getBoundingClientRect();wheel.style.transform = `rotate(${target}deg)`;
        }
        this.spinTimer = window.setTimeout(finish,duration + 80);
      });
    }
    showResult(prize,fresh) {
      if (!fresh) {
        const index = this.resolvePrizeIndex(prize);
        if (index >= 0 && this.prizes.length) {
          this.rotation = (360 - index * 360 / this.prizes.length) % 360;
          this.nodes.wheel.style.transition = 'none';this.nodes.wheel.style.transform = `rotate(${this.rotation}deg)`;
        }
      }
      this.result = prize;this.nodes.entry.hidden = true;this.nodes.result.hidden = false;
      this.nodes.result.style.animation = fresh ? '' : 'none';
      this.nodes.prize.textContent = prize.name;this.nodes.code.textContent = prize.code || '';this.nodes['code-box'].hidden = !prize.code;
      const matchedIndex = this.resolvePrizeIndex(prize);
      const image = matchedIndex >= 0 ? this.prizes[matchedIndex].image : '';
      if (this.nodes['result-image'] && this.nodes['result-img']) {
        this.nodes['result-image'].hidden = !image;
        if (image) {
          this.nodes['result-img'].alt = prize.name;
          this.nodes['result-img'].onerror = () => { this.nodes['result-image'].hidden = true; };
          this.nodes['result-img'].src = image;
        } else this.nodes['result-img'].removeAttribute('src');
      }
      this.nodes['result-kicker'].textContent = prize.alreadyDrawn || !fresh ? 'This email already entered. Here is your previous prize' : this.originalKicker;
      this.nodes['result-note'].textContent = 'Save your code. Terms follow the store campaign rules.';
      this.nodes.live.textContent = `${fresh ? 'You won' : 'Previous prize'}: ${prize.name}.`;
      if (fresh) {
        this.nodes.prize.focus({preventScroll:true});
        this.confetti();if (this.winnersFeed && prize.winner) this.winnersFeed.addWinner(prize.winner);
      }
      const target = sameShopUrl(this.config.redirectUrl);
      if (this.nodes.go) { this.nodes.go.hidden = !target;if (target) this.nodes.go.href = target; }
      const shouldRedirect = fresh && !prize.alreadyDrawn && this.config.mode === 'popup';
      if (shouldRedirect && target) this.startCountdown(target);
      else {
        this.stopCountdown();
        this.nodes.countdown.textContent = shouldRedirect ? 'Prize saved. Keep browsing the store.' : '';
      }
      this.scheduleDialogFit();
    }
    startCountdown(target) {
      if (this.config.mode !== 'popup') return;
      this.stopCountdown();
      this.counting = true;
      this.setCloseDisabled(true);
      this.nodes.progress.hidden = false;
      this.nodes.progress.firstElementChild.style.animation = 'none';
      void this.nodes.progress.offsetWidth;
      this.nodes.progress.firstElementChild.style.animation = '';
      const deadline = Date.now() + REDIRECT_MS;
      let lastSeconds = -1;
      const update = () => {
        const seconds = Math.max(0,Math.ceil((deadline - Date.now()) / 1000));
        if (seconds !== lastSeconds) {
          lastSeconds = seconds;
          this.nodes.countdown.textContent = `${seconds}s until redirect${this.editor ? ' (disabled in editor)' : ''}`;
        }
      };
      update();
      this.countdownInterval = window.setInterval(update,100);
      this.redirectTimer = window.setTimeout(() => {
        this.stopCountdown();
        if (this.destroyed || this.closed || !this.isConnected) return;
        if (this.editor) this.nodes.countdown.textContent = 'Countdown finished. No redirect in the theme editor.';
        else window.location.assign(target);
      },REDIRECT_MS);
    }
    stopCountdown() {
      window.clearTimeout(this.redirectTimer);
      window.clearInterval(this.countdownInterval);
      this.redirectTimer = null;
      this.countdownInterval = null;
      this.counting = false;
      if (this.nodes) {
        this.setCloseDisabled(this.busy);
        this.nodes.progress.hidden = true;
      }
    }
    confetti() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.nodes.confetti.replaceChildren();
      for (let i = 0; i < 54; i++) {
        const piece = document.createElement('i');
        if (i % 3 === 0) piece.className = 'lw-ribbon';
        piece.style.setProperty('--piece-color',['#ffd475','#ff862e','#fff4de','#db4e12'][i % 4]);
        piece.style.setProperty('--piece-x',`${Math.random() * 540 - 270}px`);
        piece.style.setProperty('--piece-y',`${Math.random() * 350 + 80}px`);
        piece.style.setProperty('--piece-rotate',`${Math.random() * 720}deg`);
        piece.style.setProperty('--piece-delay',`${Math.random() * .18}s`);
        this.nodes.confetti.append(piece);
      }
      this.later(() => this.nodes.confetti.replaceChildren(),2800);
    }
    async copyCode() {
      const code = this.result && this.result.code;
      if (!code) return;
      try {
        if (!navigator.clipboard || !window.isSecureContext) throw new Error('fallback');
        await navigator.clipboard.writeText(code);
        if (!this.destroyed) this.nodes['copy-status'].textContent = 'Code copied.';
      } catch (_) {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.setAttribute('readonly','');
        textarea.style.cssText = 'position:fixed;left:-9999px;top:0';
        this.nodes.card.append(textarea);
        textarea.select();
        let success = false;
        try { success = document.execCommand('copy'); } catch (_) { /* show manual hint */ }
        textarea.remove();
        this.nodes.copy.focus({preventScroll:true});
        this.nodes['copy-status'].textContent = success ? 'Code copied.' : 'Copy failed. Long-press or select the code above.';
      }
    }
    cancelActivity() {
      this.lifecycle = (this.lifecycle || 0) + 1;
      window.clearTimeout(this.spinTimer);this.spinTimer = null;
      if (this.requestController) this.requestController.abort();
      if (this.wheelAnimation) { this.wheelAnimation.cancel(); this.wheelAnimation = null; }
      if (this.spinResolve) { this.spinResolve(); this.spinResolve = null; }
      if (this.nodes && this.nodes.wheel) { this.nodes.wheel.style.transition = 'none';this.nodes.wheel.style.transform = `rotate(${this.rotation}deg)`; }
      this.timers.forEach(timer => window.clearTimeout(timer));
      this.timers.clear();
      this.setBusy(false);
      if (this.result && !this.destroyed) this.showResult(this.result,false);
    }
    disconnectedCallback() {
      window.clearTimeout(this.initTimer);
      this.initTimer = null;
      if (!this.ready) return;
      this.destroyed = true;
      this.cancelMinimize();this.hideDock();
      if (this.fitObserver) { this.fitObserver.disconnect();this.fitObserver = null; }
      window.cancelAnimationFrame(this.fitFrame);this.fitFrame = null;
      if (this.winnersFeed) { this.winnersFeed.dispose(); this.winnersFeed = null; }
      if (this.catalogController) this.catalogController.abort();
      this.stopCountdown();
      this.cancelActivity();
      this.listeners.forEach(remove => remove());
      if (this.dialog) {
        if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
        this.nodes.host.append(this.nodes.card);
        this.dialog.remove();
        this.dialog = null;
      }
      if (this.backdrop) this.backdrop.remove();
      this.nodes.lights.replaceChildren();
      this.nodes.confetti.replaceChildren();
      if (activePopup === this) { activePopup = null; unlockScroll(); }
      this.ready = false;
    }
  }
  customElements.define('lucky-wheel-section',LuckyWheel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-sunshine-background"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const springSections = document.querySelectorAll('.section__spring-sunshine');
    springSections.forEach(function (section) {
      const canvas = section.querySelector('.spring-canvas');
      if (!canvas) return;

      const ctx = canvas.getContext('2d');

      let petals = [];
      let pollen = [];
      let leaves = [];
      let butterflies = [];

      // Spring color palette
      const petalColors = [
        '#FFB7C5', // Cherry blossom pink
        '#FF85A1', // Deep pink
        '#FFC0CB', // Light pink
        '#FFD1DC', // Blush
        '#FFDDE1', // Very light pink
        '#FFF0F5', // Lavender blush
        '#FFFACD', // Lemon chiffon (white blossom)
        '#F8E1F4', // Thistle
      ];

      const leafColors = [
        '#7EC850', // Fresh green
        '#A8D770', // Light green
        '#5BAD3A', // Medium green
        '#C5E89A', // Pale green
        '#90C83C', // Yellow-green
      ];

      const pollenColor = 'rgba(255, 235, 59, 0.75)';

      // ─── Resize ───────────────────────────────────────────
      function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        init();
      }

      // ─── Init all elements ────────────────────────────────
      function init() {
        petals = [];
        pollen = [];
        leaves = [];
        butterflies = [];

        const petalCount = Math.max(18, Math.floor(canvas.width / 55));
        for (let i = 0; i < petalCount; i++) {
          petals.push(createPetal(true));
        }

        const pollenCount = 60;
        for (let i = 0; i < pollenCount; i++) {
          pollen.push(createPollen(true));
        }

        const leafCount = Math.max(6, Math.floor(canvas.width / 220));
        for (let i = 0; i < leafCount; i++) {
          leaves.push(createLeaf(true));
        }

        const butterflyCount = Math.max(2, Math.floor(canvas.width / 500));
        for (let i = 0; i < butterflyCount; i++) {
          butterflies.push(createButterfly(true));
        }
      }

      // ─── Factories ────────────────────────────────────────
      function createPetal(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 40,
          y: scatter ? Math.random() * canvas.height : Math.random() * canvas.height * 0.6,
          size: Math.random() * 14 + 7,
          color: petalColors[Math.floor(Math.random() * petalColors.length)],
          speedX: -(Math.random() * 1.5 + 0.4),
          speedY: Math.random() * 0.8 + 0.3,
          wobble: Math.random() * Math.PI * 2,
          wobbleSpeed: Math.random() * 0.03 + 0.01,
          wobbleAmp: Math.random() * 30 + 10,
          rotation: Math.random() * Math.PI * 2,
          rotSpeed: (Math.random() - 0.5) * 0.04,
          opacity: Math.random() * 0.55 + 0.35,
        };
      }

      function createPollen(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 5,
          y: scatter ? Math.random() * canvas.height : Math.random() * canvas.height,
          size: Math.random() * 2.5 + 1,
          speedX: -(Math.random() * 0.8 + 0.2),
          speedY: (Math.random() - 0.4) * 0.5,
          opacity: Math.random() * 0.5 + 0.2,
          pulse: Math.random() * 0.04 + 0.01,
          t: Math.random() * Math.PI * 2,
        };
      }

      function createLeaf(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 30,
          y: scatter ? Math.random() * canvas.height * 0.7 : Math.random() * canvas.height * 0.5,
          width: Math.random() * 28 + 16,
          height: Math.random() * 14 + 8,
          color: leafColors[Math.floor(Math.random() * leafColors.length)],
          speedX: -(Math.random() * 1.2 + 0.3),
          speedY: Math.random() * 0.6 + 0.2,
          wobble: Math.random() * Math.PI * 2,
          wobbleSpeed: Math.random() * 0.025 + 0.008,
          wobbleAmp: Math.random() * 25 + 10,
          rotation: Math.random() * Math.PI,
          rotSpeed: (Math.random() - 0.5) * 0.025,
          opacity: Math.random() * 0.4 + 0.25,
        };
      }

      function createButterfly(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 40,
          y: scatter ? Math.random() * canvas.height * 0.7 : Math.random() * canvas.height * 0.6,
          size: Math.random() * 14 + 10,
          speedX: -(Math.random() * 1.0 + 0.3),
          speedY: 0,
          t: Math.random() * Math.PI * 2,
          flapSpeed: Math.random() * 0.1 + 0.06,
          color1: petalColors[Math.floor(Math.random() * petalColors.length)],
          color2: '#FFD700',
          opacity: Math.random() * 0.4 + 0.4,
          driftAmp: Math.random() * 40 + 20,
          driftFreq: Math.random() * 0.015 + 0.005,
          baseY: 0,
        };
      }

      // ─── Draw functions ───────────────────────────────────

      function drawPetal(p) {
        p.wobble += p.wobbleSpeed;
        p.rotation += p.rotSpeed;
        p.x += p.speedX + Math.sin(p.wobble) * 0.5;
        p.y += p.speedY;

        if (p.x < -30 || p.y > canvas.height + 30) {
          Object.assign(p, createPetal(false));
          return;
        }

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.globalAlpha = p.opacity;

        // Petal shape: two ellipses meeting at a point
        ctx.beginPath();
        ctx.ellipse(0, -p.size * 0.4, p.size * 0.45, p.size * 0.9, 0, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.shadowColor = p.color;
        ctx.shadowBlur = 6;
        ctx.fill();

        // Subtle center line
        ctx.beginPath();
        ctx.moveTo(0, -p.size * 0.9);
        ctx.lineTo(0, p.size * 0.5);
        ctx.strokeStyle = 'rgba(255,150,160,0.3)';
        ctx.lineWidth = 0.8;
        ctx.stroke();

        ctx.restore();
      }

      function drawPollen(p) {
        p.t += p.pulse;
        p.x += p.speedX;
        p.y += p.speedY + Math.sin(p.t) * 0.3;
        p.opacity = Math.abs(Math.sin(p.t * 0.8)) * 0.45 + 0.15;

        if (p.x < -5) {
          Object.assign(p, createPollen(false));
          return;
        }

        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = pollenColor;
        ctx.shadowColor = '#FFE066';
        ctx.shadowBlur = 5;
        ctx.fill();
        ctx.restore();
      }

      function drawLeaf(l) {
        l.wobble += l.wobbleSpeed;
        l.rotation += l.rotSpeed;
        l.x += l.speedX + Math.sin(l.wobble * 0.7) * 0.4;
        l.y += l.speedY;

        if (l.x < -40 || l.y > canvas.height + 30) {
          Object.assign(l, createLeaf(false));
          return;
        }

        ctx.save();
        ctx.translate(l.x, l.y);
        ctx.rotate(l.rotation + Math.sin(l.wobble) * 0.2);
        ctx.globalAlpha = l.opacity;

        // Leaf shape
        ctx.beginPath();
        ctx.save();
        ctx.scale(1, l.height / l.width);
        ctx.arc(0, 0, l.width / 2, 0, Math.PI * 2);
        ctx.restore();
        ctx.fillStyle = l.color;
        ctx.shadowColor = l.color;
        ctx.shadowBlur = 4;
        ctx.fill();

        // Mid vein
        ctx.beginPath();
        ctx.moveTo(-l.width * 0.45, 0);
        ctx.lineTo(l.width * 0.45, 0);
        ctx.strokeStyle = 'rgba(255,255,255,0.35)';
        ctx.lineWidth = 0.8;
        ctx.stroke();

        ctx.restore();
      }

      function drawButterfly(b) {
        b.t += b.flapSpeed;
        b.x += b.speedX;
        b.y = b.baseY + Math.sin(b.t * b.driftFreq * 80) * b.driftAmp;

        if (b.x < -50) {
          Object.assign(b, createButterfly(false));
          b.baseY = b.y;
          return;
        }
        if (b.baseY === 0) b.baseY = b.y;

        const flapAngle = Math.abs(Math.sin(b.t)) * 0.8; // 0 = open, 0.8 = closed

        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.globalAlpha = b.opacity;

        // Left wings
        ctx.save();
        ctx.scale(-1 + flapAngle, 1);
        // Upper wing
        ctx.beginPath();
        ctx.ellipse(-b.size * 0.5, -b.size * 0.3, b.size * 0.7, b.size * 0.5, -0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color1;
        ctx.shadowColor = b.color1;
        ctx.shadowBlur = 5;
        ctx.fill();
        // Lower wing
        ctx.beginPath();
        ctx.ellipse(-b.size * 0.4, b.size * 0.25, b.size * 0.5, b.size * 0.35, 0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color2;
        ctx.fill();
        ctx.restore();

        // Right wings
        ctx.save();
        ctx.scale(1 - flapAngle, 1);
        ctx.beginPath();
        ctx.ellipse(b.size * 0.5, -b.size * 0.3, b.size * 0.7, b.size * 0.5, 0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color1;
        ctx.shadowColor = b.color1;
        ctx.shadowBlur = 5;
        ctx.fill();
        ctx.beginPath();
        ctx.ellipse(b.size * 0.4, b.size * 0.25, b.size * 0.5, b.size * 0.35, -0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color2;
        ctx.fill();
        ctx.restore();

        // Body
        ctx.beginPath();
        ctx.ellipse(0, 0, 1.5, b.size * 0.4, 0, 0, Math.PI * 2);
        ctx.fillStyle = '#5D3A1A';
        ctx.globalAlpha = b.opacity * 0.7;
        ctx.fill();

        ctx.restore();
      }

      // ─── Animation loop ───────────────────────────────────
      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        pollen.forEach(drawPollen);
        leaves.forEach(drawLeaf);
        petals.forEach(drawPetal);
        butterflies.forEach(drawButterfly);

        requestAnimationFrame(animate);
      }

      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      animate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starry-sky"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const starrySections = document.querySelectorAll('.section__starry-sky');
    starrySections.forEach(function (section) {
      const canvas = section.querySelector('.starry-sky-canvas');
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      let stars = [];
      let shootingStars = [];

      function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        initStars();
      }

      function initStars() {
        stars = [];
        const starCount = Math.floor((canvas.width * canvas.height) / 3000);

        for (let i = 0; i < starCount; i++) {
          stars.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            size: Math.random() * 2,
            brightness: Math.random(),
            twinkleSpeed: Math.random() * 0.05 + 0.01,
          });
        }
      }

      function createShootingStar() {
        if (Math.random() < 0.01 && shootingStars.length < 3) {
          shootingStars.push({
            x: Math.random() * canvas.width,
            y: 0,
            length: Math.random() * 80 + 20,
            speed: Math.random() * 10 + 5,
            opacity: 1,
            angle: Math.random() * 60 + 30,
          });
        }
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw stars
        stars.forEach((star) => {
          star.brightness += star.twinkleSpeed;
          if (star.brightness > 1 || star.brightness < 0) {
            star.twinkleSpeed = -star.twinkleSpeed;
          }

          ctx.beginPath();
          ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255, 255, 255, ${star.brightness * 0.8})`;
          ctx.fill();

          // Add glow effect for larger stars
          if (star.size > 1) {
            ctx.beginPath();
            ctx.arc(star.x, star.y, star.size * 2, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(255, 255, 255, ${star.brightness * 0.2})`;
            ctx.fill();
          }
        });

        // Draw and update shooting stars
        shootingStars = shootingStars.filter((star) => {
          const radians = (star.angle * Math.PI) / 180;
          star.x += Math.cos(radians) * star.speed;
          star.y += Math.sin(radians) * star.speed;
          star.opacity -= 0.02;

          if (star.opacity > 0 && star.y < canvas.height) {
            const gradient = ctx.createLinearGradient(
              star.x,
              star.y,
              star.x - Math.cos(radians) * star.length,
              star.y - Math.sin(radians) * star.length
            );
            gradient.addColorStop(0, `rgba(255, 255, 255, ${star.opacity})`);
            gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

            ctx.strokeStyle = gradient;
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(star.x, star.y);
            ctx.lineTo(star.x - Math.cos(radians) * star.length, star.y - Math.sin(radians) * star.length);
            ctx.stroke();

            return true;
          }
          return false;
        });

        createShootingStar();
        requestAnimationFrame(animate);
      }

      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      animate();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
